export default __webpack_public_path__ + "static/media/enable-cam-ff-pc.a76cc5e4.png";